<div #mask class="init-loader">
  <div class="spinner--wrapper">
      <span class="spinner"
            role="status">
        <span class="sr-only">Loading...</span>
      </span>
  </div>
</div>

